import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { Layout3 } from "../ContentBox";
import { DivHover, DivHelp } from "./styled";

class ImageTextView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="ImageTextView" />
        {this.state.hover && <DivHelp>Content</DivHelp>}
      </DivHover>
    );
  }
}

ImageTextView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func
};
/*

*/
ImageTextView.defaultProps = {
  childOf: "Content",
  values: {
    parent: "Content",
    type: "ImageTextView",
    containerPadding: "0px",
    backgroundColor: "rgba(255,255,255,0)",
    text: {
      containerPadding: "0px",
      backgroundColor: "rgba(255,255,255,0)",
      lineHeight: "120%",
      letterSpacing: "1px",
      value:
        "<div>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div>"
    },
    backgroundImage: {
      url: "",
      urlMobile: "",
      desktop: {
        width: 0,
        height: 0
      },
      mobile: {
        width: 0,
        height: 0
      }
    }
  },
  layout: Layout3
};
export default ImageTextView;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Content/ImageTextView.js